import React, { useEffect, useState } from 'react';
import { Box, Button, Typography, useTheme } from '@mui/material';
import { CardItem } from '@europrocurement/flexy-components';
import { DossierDocumentSign } from '../../../providers/types';

export type SelectDossierSignModalProps = {
    dossiers: Array<DossierDocumentSign>;
    onSubmit: (dossier: DossierDocumentSign) => void;
    onCancel: () => void;
};

const SelectDossierSignModal: React.FunctionComponent<SelectDossierSignModalProps> = function (
    props,
) {
    const { dossiers, onSubmit, onCancel } = props;
    const [selectedItem, setSelectedItem] = useState<DossierDocumentSign>();
    const { palette } = useTheme();

    const handleSubmit = () => {
        if (!selectedItem) {
            return;
        }

        onSubmit(selectedItem);
    };

    useEffect(() => {
        setSelectedItem(undefined);
    }, [dossiers]);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', rowGap: '1em', maxWidth: '480px' }}>
            <Typography variant="l2dh6">Sélectionner un dossier de signature</Typography>
            <Typography variant="l2dbodys">
                Ce document est présent dans plusieurs dossiers de signature. Lequel souhaitez-vous
                télécharger ?
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', rowGap: '0.5em' }}>
                {dossiers.map((dossier) => (
                    <CardItem
                        key={dossier.subject}
                        title={dossier.subject}
                        icon={dossier.id === selectedItem?.id ? 'check' : 'folder'}
                        borderColor={dossier.id === selectedItem?.id ? palette.primary : undefined}
                        color={dossier.id === selectedItem?.id ? palette.primary : undefined}
                        onClick={() => setSelectedItem(dossier)}
                    />
                ))}
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', columnGap: '1em' }}>
                <Button
                    variant="text"
                    onClick={onCancel}
                    sx={{ color: palette.primary.dark }}
                >
                    Annuler
                </Button>
                <Button
                    variant="contained"
                    onClick={handleSubmit}
                    sx={{
                        display: 'flex',
                        columnGap: '0.5em',
                        padding: '16px 24px',
                        background: palette.primary.dark,
                    }}
                    disabled={selectedItem === undefined}
                >
                    Télécharger le document
                </Button>
            </Box>
        </Box>
    );
};

export default SelectDossierSignModal;
